<template>
    <p class="remind" style="font-size: 14px;" v-if="is_error">
        {{message}}
    </p>
</template>

<script>
export default {
    name: 'InputMsg',
    props:{  
        title: '',
        value:''
    },
    data () {
        return {
            is_error:false,
            message:''
        }
    },
    mounted() {
    },
    watch: {
        value:function() {
            this.check();
        } 
    },
    methods: {
        check() {
            if ( this.value.length == '' ) {
                this.message = '請填寫' + this.title;
                this.is_error = true;
                this.$emit('verify', false);
            } else if ( this.value.length > 1000 ) {
                this.message = this.title + '不可超過1000個字';
                this.is_error = true;
                this.$emit('verify', false);
            } else {
                this.is_error = false;
                this.$emit('verify', true); 
            }
        }
    }
}
</script>

<style scoped>
label{
  cursor: pointer;
}
label span, .remind{
  color:#BE0000
}
</style>



// WEBPACK FOOTER //
// src/components/shared/InputMsg.vue